<template>
  <div
    :class="fieldClass"
    class="field field--textarea"
  >
    <label
      v-if="hasLabel"
      :for="name"
    >
      {{ label }}
    </label>
    <div class="field__input">
      <textarea
        ref="input"
        :id="name"
        :disabled="disabled"
        :placeholder="placeholder"
        :name="name"
        @input="updateValue"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>
    <div
      v-show="showError"
      class="field__error"
    >
      {{ errorMsg }}
    </div>
    <div
      v-show="showRequiredError"
      class="field__error"
    >
      This field is required.
    </div>
  </div>
</template>

<script>
// Mixins
import FormInputMixin from '../../mixins/forms/FormInputMixin'

export default {
  name: 'TextAreaInput',
  mixins: [
    FormInputMixin
  ],
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.setInputValue()
      }
    }
  },
  methods: {
    setInputValue () {
      if (this.$refs.input) {
        this.$refs.input.value = this.value
      }
    }
  },
  mounted () {
    this.setInputValue()
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

textarea
  background-clip: padding-box
  background-color: $input-bg-color
  border-color: $input-border-color
  border-radius: 1.5px
  border-style: solid
  border-width: 1px
  color: $input-text-color
  box-sizing: border-box
  box-shadow: inset 0 2px 1px rgba(0, 0, 0, 0.025)
  color: $input-text-color
  font-family: inherit
  font-size: 13px
  font-weight: 400
  line-height: 1.3
  min-height: 150px
  outline: none
  padding: 10px 11px
  text-shadow: none
  width: 100%
  margin-top: 2px
  letter-spacing: .3px
  display: block

  @include desktop
    padding-left: 15px
    padding-right: 15px

  &[disabled]
    opacity: 0.5

  &:focus
    border-color: $input-border-color-focus

  &::placeholder
    color: $input-text-placeholder-color

.field--error
  textarea
    border-color: rgba($input-error-color, .3)

    &::-webkit-input-placeholder,
    &:-moz-placeholder,
    &::-moz-placeholder,
    &:-ms-input-placeholder
      color: $input-error-color
</style>



// WEBPACK FOOTER //
// src/components/forms/TextAreaInput.vue